import * as yup from 'yup';

const SupportSchema = yup.object({
  reason: yup.string().required('Reason is required'),
  message: yup.string().required('Message is required'),
});

export { SupportSchema };
